module.exports = __webpack_public_path__ + "img/draw.19797900.svg";